import { FormikProps } from "formik";

export type AddAccountFormData = {
  clientAccountNumber: string;
  emailAddress: string;
  emailVerificationCode: string;
};

export enum AddAccountFormSteps {
  ClientAccountNumber,
  EmailAddress,
  EmailVerificationCode,
  Success,
}

export type AddAccountStepProps = {
  currentStep: AddAccountFormSteps;
  formikProps: FormikProps<AddAccountFormData>;
};
